// Inventory Raw Materials Vuex

import state from './rawMaterialStates.js'
import * as getters from './rawMaterialGetters.js'
import * as mutations from './rawMaterialMutations.js'
import * as actions from './rawMaterialActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
